/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import cx from 'classnames';
import CurrentPageContext from '../../../../contexts/CurrentPageContext';
import {
  TRACK_CLICK_SIZE_SORT,
  TRACK_CLICK_PRICE_SORT,
} from '../../../../../src/web/utils/dataLayer';
import styles from './ThemeTwo.scss';
import UnitTier from '../TierPricing/UnitTier';
import useEventTrigger from '../../../../../modules/react/hooks/useEventTrigger';

function ThemeTwo({ facility, columnHeadings, units, actionButtons, priceDisplay }) {
  const context = useContext(CurrentPageContext);
  const { primaryColorClass } = context;
  const { addEvent } = useEventTrigger();


  const [isAscending, setIsAscending] = useState(true);
  const [sortBy, setSortBy] = useState('price');

  const getAnalyticsPayload = sizeList => ({
    facilityId: facility.id,
    eventLocation: 'themeTwo',
    sortOrder: isAscending ? 'ascending' : 'descending',
    unitsSorted: sizeList,
    timeStamp: Date.now(),
  });

  const getArrowColor = (label, isUpArrow) => (sortBy === label && isAscending === isUpArrow ? primaryColorClass : '');

  const comparator = (a, b) => {
    let value = 0;
    if (sortBy === 'size') {
      value = b.area - a.area;
    } else if (sortBy === 'price') {
      value = b.price - a.price;
    }
    return isAscending ? -value : value;
  };

  const sort = (label) => {
    setSortBy(label);
    setIsAscending(prev => !prev);

    const sortedItems = units.slice().sort(comparator);
    const sizeList = sortedItems.map(item => item.size);
    const analyticsPayload = getAnalyticsPayload(sizeList);
    const event = label === 'size' ? TRACK_CLICK_SIZE_SORT : TRACK_CLICK_PRICE_SORT;
    if (addEvent) {
      addEvent(event, analyticsPayload, 'click');
    }
  };

  const renderSortArrow = (isUpArrow, label) => {
    const classNames = [
      'icon',
      isUpArrow ? 'icon-filter-arrow-up' : 'icon-filter-arrow-down',
      getArrowColor(label.toLowerCase(), isUpArrow),
      styles.icon,
    ];

    return <span className={cx(classNames)} />;
  };

  const renderUnitTier = group => (
    <UnitTier
      key={group.id}
      group={group}
      facility={facility}
      actionButtons={actionButtons}
      parentTheme="ThemeTwo"
      priceDisplay={priceDisplay}
    />
  );

  const renderHeadings = () => (
    <Row className={styles.header}>
      <Col
        xs={3}
        sm={2}
        className={styles.heading}
        onClick={() => sort('price')}
        data-testid="priceSort"
        {...TRACK_CLICK_PRICE_SORT}
      >
        <span className={styles.sort}>
          <span>{columnHeadings.price}</span>
          <span className={styles.arrows}>
            {renderSortArrow(true, 'price')}
            {renderSortArrow(false, 'price')}
          </span>
        </span>
      </Col>
      <Col
        xs={8}
        sm={8}
        md={8}
        className={styles.headings}
        onClick={() => sort('size')}
        data-testid="sizeSort"
        {...TRACK_CLICK_PRICE_SORT}
      >
        <span className={styles.sort}>
          <span>{columnHeadings.size}</span>
          <span className={styles.arrows}>
            {renderSortArrow(true, 'size')}
            {renderSortArrow(false, 'size')}
          </span>
        </span>
      </Col>
      <Col xs={1} sm={2} />
    </Row>
  );

  const sortedUnits = units.slice().sort(comparator);

  return (
    <div>
      {renderHeadings()}
      {sortedUnits.map(renderUnitTier)}
    </div>
  );
}

ThemeTwo.propTypes = {
  facility: PropTypes.shape({}).isRequired,
  columnHeadings: PropTypes.shape({
    size: PropTypes.number,
    price: PropTypes.number,
  }).isRequired,
  units: PropTypes.arrayOf(PropTypes.object).isRequired,
  actionButtons: PropTypes.shape({
    call: PropTypes.string.isRequired,
    moveIn: PropTypes.string.isRequired,
    reserve: PropTypes.string.isRequired,
  }).isRequired,
  priceDisplay: PropTypes.object.isRequired,
};

export default ThemeTwo;
